import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

const getAuthConfig = (token) => ({
  headers: { Authorization: `Bearer ${token}` }
});

export const listCustomers = async (token, { page = 1, limit = 20, search = '' } = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (search) params.append('search', search);
  const response = await axios.get(`${API_ENDPOINTS.CUSTOMERS}?${params}`, getAuthConfig(token));
  return response.data.data || response.data;
};

export const getCustomer = async (token, id) => {
  const response = await axios.get(`${API_ENDPOINTS.CUSTOMERS}/${id}`, getAuthConfig(token));
  return response.data.data || response.data;
};

export const createCustomer = async (token, data) => {
  const response = await axios.post(API_ENDPOINTS.CUSTOMERS, data, getAuthConfig(token));
  return response.data.data || response.data;
};

export const updateCustomer = async (token, id, data) => {
  const response = await axios.put(`${API_ENDPOINTS.CUSTOMERS}/${id}`, data, getAuthConfig(token));
  return response.data.data || response.data;
};

export const getVisitHistory = async (token, id, { page = 1, limit = 20 } = {}) => {
  const params = new URLSearchParams({ page, limit });
  const response = await axios.get(`${API_ENDPOINTS.CUSTOMERS}/${id}/visits?${params}`, getAuthConfig(token));
  return response.data.data || response.data;
};

export const createVisit = async (token, customerId, data) => {
  const response = await axios.post(`${API_ENDPOINTS.CUSTOMERS}/${customerId}/visits`, data, getAuthConfig(token));
  return response.data.data || response.data;
};

export const updateVisit = async (token, customerId, visitId, data) => {
  const response = await axios.put(`${API_ENDPOINTS.CUSTOMERS}/${customerId}/visits/${visitId}`, data, getAuthConfig(token));
  return response.data.data || response.data;
};

export const deleteVisit = async (token, customerId, visitId) => {
  const response = await axios.delete(`${API_ENDPOINTS.CUSTOMERS}/${customerId}/visits/${visitId}`, getAuthConfig(token));
  return response.data;
};

export const deleteCustomer = async (token, id) => {
  const response = await axios.delete(`${API_ENDPOINTS.CUSTOMERS}/${id}`, getAuthConfig(token));
  return response.data;
};

// 疑似重複客戶複核 API

export const getDuplicateCustomers = async (token) => {
  const response = await axios.get(`${API_ENDPOINTS.ADMIN}/customers/duplicates`, getAuthConfig(token));
  return response.data.data || response.data;
};

export const mergeCustomer = async (token, id, targetId) => {
  const response = await axios.post(`${API_ENDPOINTS.ADMIN}/customers/${id}/merge`, { targetId }, getAuthConfig(token));
  return response.data.data || response.data;
};

export const dismissDuplicate = async (token, id) => {
  const response = await axios.post(`${API_ENDPOINTS.ADMIN}/customers/${id}/dismiss-duplicate`, {}, getAuthConfig(token));
  return response.data.data || response.data;
};
